import Vue from 'vue'
import VueRouter from 'vue-router'
import SignUp from '@/views/Auth/SignUp'
import FinishSignUp from '@/views/Auth/FinishSignUp'
import SignIn from '@/views/Auth/SignIn'
import Profile from '@/views/User/Profile'
import Error404 from '@/views/Error404'
import Content from '@/components/Templates//Content'
import Register from '@/views/Registers/Register'
import List from '@/views/Registers/List'
import IntegrationsRegister from '@/views/Registers/IntegrationsRegister'
import IntegrationsList from '@/views/Registers/IntegrationsList'
import UsersList from '@/views/Registers/UsersList'
import UsersRegister from '@/views/Registers/UsersRegister'
import UserRulesRegister from '@/views/Registers/UserRulesRegister'
import UserRulesList from '@/views/Registers/UserRulesList'

Vue.use(VueRouter)

// let userRules = [];

/**
 * Função auxiliar para criação de rotas dinâmicas, cria rotas de listagem, edição, vizualização e cadastro dada as condigurações recebidas por parâmetro
 */
const createCrudRoutes = ({ route, props, registerComponent, listComponent, userRules}) => {
  route.component = Content
  route.children = [];

  // props.claims.view = props.claims.view && (userData?.claims?.admin || userData?.rules?.find(rId => userRules.find(ur => ur.id === rId && eval(`ur.claims?.${props.register}?.view`))))
  // props.claims.add = props.claims.add && (userData?.claims?.admin || userData?.rules?.find(rId => userRules.find(ur => ur.id === rId && eval(`ur.claims?.${props.register}?.add`))))
  // props.claims.edit = props.claims.edit && (userData?.claims?.admin || userData?.rules?.find(rId => userRules.find(ur => ur.id === rId && eval(`ur.claims?.${props.register}?.edit`))))
  // props.claims.delete = props.claims.delete && (userData?.claims?.admin || userData?.rules?.find(rId => userRules.find(ur => ur.id === rId && eval(`ur.claims?.${props.register}?.delete`))))

  // props.claims.view 

  if (props.claims.view ) 
    route.children.push({
      path: "listar",
      name: `Listar ${route.name}`,
      component: listComponent,
      props,
      meta: { ...route.meta, menu: true, title: "Listar", claimRoute: 'view', icon: "mdi-format-list-bulleted" }
    },
    {
      path: "detalhes/:id",
      name: `Detalhes do Item - ${route.name}`,
      component: registerComponent,
      props: { ...props, readonly: true },
      meta: { ...route.meta, menu: false, claimRoute: 'view', title: "Detalhes" }
    })
   
  // if (props.claims.add && (userData?.claims?.admin || userData?.rules?.find(rId => userRules.find(ur => ur.id === rId && eval(`ur.claims?.${props.register}?.add`)))))
  if (props.claims.add){
    route.children.push({
      path: "cadastrar",
      name: `Cadastrar ${route.name}`,
      component: registerComponent,
      props,
      meta: { ...route.meta, menu: true, title: "Cadastrar", claimRoute: 'add', icon: "mdi-plus" }
    })

    /**
     * TO-DO
     * Lembrar de fazer esse tratamento para cópia e deixar algo mais genérico
     */
    if (route.register === 'SC5')
    route.children.push({
      path: "bonificar/:id",
      name: `Bonificar ${route.name}`,
      component: registerComponent,
      props,
      meta: { ...route.meta, menu: false, title: "Cadastrar", claimRoute: 'add', icon: "mdi-plus" }
    })
  }

  // if (props.claims.edit && (userData?.claims?.admin || userData?.rules?.find(r => eval(`r.claims?.${props.register}?.edit`))))
  if (props.claims.edit)
    route.children.push({
      path: "editar/:id",
      name: `Editar Item - ${route.name}`,
      component: registerComponent,
      props: { ...props, edit: true },
      meta: { ...route.meta, menu: false, claimRoute: 'edit', title: "Editar" }
    })

  return route
}

const createRouter = (integrations, userRules = []) => {
  // Filtrar integrações pelas rules
  // const integrationsFiltered = userData?.claims?.admin ? integrations : integrations.filter(i => 
  //   userData?.rules?.find(rId => userRules?.find(ur => ur.id === rId && eval(`ur.claims?.${i.register}?.view`)))
  // )

  // Cria as rotas de listagem, edição, cadastro e visualização de cada integração cadastrada  
  const routesFromIntegrations = integrations.map(integration => {

    let orderBy = integration.orderBy || ''
    try {
      if (['{', '['].some(symbol => orderBy.includes(symbol)))
        orderBy = JSON.parse(orderBy)
    } catch (e) {
      console.warn(`Error when trying to define "orderBy" in route ${integration.name}.`, e)
    }

    let filters = ''
    try {
      filters = (integration.filters) ? JSON.parse(integration.filters) : null
    } catch (e) {
      console.warn(`Error when trying to define "filters" in route ${integration.name}.`, e)
    }

    let orderSubcollection = integration.orderSubcollection || ''
    try {
      if (['{', '['].some(symbol => orderSubcollection.includes(symbol)))
        orderSubcollection = JSON.parse(orderSubcollection)
    } catch (e) {
      console.warn(`Error when trying to define "orderSubcollection" in route ${integration.name}.`, e)
    }

    const parentRoute = {
      path: `/${integration.collection}`,
      name: integration.name,
      register: integration.register,
      meta: {
        menu: true,
        icon: integration.listIcon || 'mdi-lan-connect',
        requiresAdmin: integration.requiresAdmin || false
      },
    }

    // props comum a todas as rotas do crud
    const props = {
      ...integration,
      integration: true,
      filters,
      orderBy,
      orderSubcollection,
      claims: {
        add: ('add' in integration) ? integration.add : false,
        sync: ('sync' in integration) ? integration.sync : false,
        view: ('view' in integration) ? integration.view : true,
        edit: ('edit' in integration) ? integration.edit : false,
        delete: ('delete' in integration) ? integration.delete : false,
        approval: ('approval' in integration) ? integration.approval : false,
      },
    }

    return createCrudRoutes({ route: parentRoute, props, registerComponent: Register, listComponent: List, userRules})
  })

  let generatedRoutes = [
    ...routesFromIntegrations
  ]
  // if (userData?.claims?.admin) {
    const integrationsRoute = {
      path: '/integrations',
      name: 'Integrações',
      register: 'integrations',
      meta: {
        menu: true,
        icon: 'mdi-lan-connect',
        requiresAdmin: true
      },
    }

    const integrationsRoutesProps = {
      collection: 'integrations',
      register: 'integrations',
      orderBy: 'menuOrder',
      claims: {
        add: true,
        sync: false,
        view: true,
        edit: true,
        delete: true,
      },
    }

    const usersRoute = {
      path: '/users',
      name: 'Usuários',
      register: 'users',
      meta: {
        menu: true,
        icon: 'mdi-account-multiple-outline',
        requiresAdmin: true
      },
    }

    const userRoutesProps = {
      collection: 'users',
      register: 'users',
      claims: {
        add: true,
        sync: false,
        view: true,
        edit: true,
        delete: true,
      },
    }

    const userRulesRoute = {
      path: '/userRules',
      name: 'Papéis de Usuários',
      register: 'userRules',
      meta: {
        menu: true,
        icon: 'mdi-account-key',
        requiresAdmin: true
      },
    }

    const userRulesRoutesProps = {
      collection: 'userRules',
      register: 'userRules',
      claims: {
        add: true,
        sync: false,
        view: true,
        edit: true,
        delete: true,
      },
    }
    generatedRoutes.push(
      // Cria as de listagem, edição, cadastro e visualização de Usuários.
      createCrudRoutes({ route: usersRoute, registerComponent: UsersRegister, listComponent: UsersList, props: userRoutesProps, userRules }),
      // Cria as rotas de listagem, edição, cadastro e visualização de Integrações.
      createCrudRoutes({ route: integrationsRoute, registerComponent: IntegrationsRegister, listComponent: IntegrationsList, props: integrationsRoutesProps, userRules }),
      // Cria as rotas de listagem, edição, cadastro e visualização de Integrações.
      createCrudRoutes({ route: userRulesRoute, registerComponent: UserRulesRegister, listComponent: UserRulesList, props: userRulesRoutesProps, userRules })
    )
  // }

  const routes = [
    {
      path: '/register',
      name: 'Registrar',
      component: SignUp,
      meta: { public: true, menuPublic: true }
    },
    {
      path: '/finishSignUp',
      name: 'FinishSignUp',
      component: FinishSignUp,
      meta: { public: true }
    },
    {
      path: '/login',
      name: 'Entrar',
      component: SignIn,
      meta: { public: true, menuPublic: true }
    },
    {
      path: '/404',
      name: 'Error404',
      component: Error404,
      meta: { public: true }
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile,
      meta: { icon: 'mdi-account-edit' }
    },
    {
      path: '/',
      name: 'Home',
      component: Content,
      meta: { menu: true, icon: 'mdi-account-multiple-outline' },
      props: {
        component: UsersList,
        props: {
          claims: {
            add: true,
            sync: false,
            view: true,
            edit: true,
            delete: true,
          },
        }
      }
    },

    ...generatedRoutes
  ]

  const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
  })

  router.beforeEach((to, from, next) => {
    const json = localStorage.getItem(process.env.VUE_APP_USERKEY)
    const userData = JSON.parse(json)
    if (to.matched.some(route => route.meta.requiresAdmin)) {
      const register = to.matched[0].path.substring(1)
      if (
        userData?.claims?.admin 
        || (userData?.rules.some(x => x.claims && x.claims[register] && x.claims[register].view) && (to.matched[1].path.includes('/listar') || to.matched[1].path.includes('/detalhes')))
        || (userData?.rules.some(x => x.claims && x.claims[register] && x.claims[register].add) && to.matched[1].path.includes('/cadastrar'))
        || (userData?.rules.some(x => x.claims && x.claims[register] && x.claims[register].edit) && to.matched[1].path.includes('/editar'))
      ) {
        next()
      } else {
        next('/')
        return
      }
    } else {
      // TODO Redirect Provisorio
      if (to.path == '/') next('/SC5/listar')
      else next()
    }
  })

  return router
}

export default createRouter